// Parts of the site loaded on demand, each in its own chunk, so a clinic site doesn't download the
// Lotus Code, GSM and patient-link apps it never shows, and Cloudscape (used on clinic sites only by
// the Appointment form) only loads on that page.
// A .mjs file because the project's ESLint parser (babel-eslint 7) can't read import(); webpack bundles
// .mjs without Babel, and needs the file extensions on relative imports here.
import React from "react";

const siteApps = {
  med: () => import(/* webpackChunkName: "app-med" */ "./AppMed.js"),
  lab: () => import(/* webpackChunkName: "app-lab" */ "./AppLab.js"),
  lotus: () => import(/* webpackChunkName: "app-lotus" */ "./AppLotus.js"),
  gsm: () => import(/* webpackChunkName: "app-gsm" */ "./AppGSM.js"),
  link: () => import(/* webpackChunkName: "app-link" */ "./AppLink.js")
};

export const AppMed = React.lazy(siteApps.med);
export const AppLab = React.lazy(siteApps.lab);
export const AppLotus = React.lazy(siteApps.lotus);
export const AppGSM = React.lazy(siteApps.gsm);
export const AppLink = React.lazy(siteApps.link);

// Starts downloading the app of a site type (the client type from /api/online/Start) while App.js still
// waits for the company data; webpack loads each chunk once, so the lazy component above reuses it
export const preloadSiteApp = type => {
  if (siteApps[type])
    siteApps[type]().catch(() => { /* the lazy component retries and reports it when it renders */ });
};

export const Appointment = React.lazy(() => import(/* webpackChunkName: "appointment" */ "./Online/Appointment.tsx"));

export const loadCloudscapeTheming = () => import(/* webpackChunkName: "cloudscape-theming" */ "@cloudscape-design/components/theming");
